export default {
  title: {
    en: 'You successfully switched your plan',
  },
  text: {
    en: `
    Your shipping frequency has been updated to once every {period, plural, one {# month} other {# months}}.<br />
    Your next fragrance will be shipped between {date}
  `,
  },
  hint: {
    en: 'Remember: You can always update your subscription frequency under the “Profile” drop-down',
  },
}
